export const OPEN_MENU = 'OPEN_MENU';